import { Vue, MsgBox } from '../../app.vues'

import SwbRecordReservedInfo from './RecordReservedInfo';
Vue.regist(SwbRecordReservedInfo);

export function openRecordReservedInfoDlg(reservedPayNo, reservedPayTime, callback) {
    //
    Vue.$showDialog({
        title: '付款单 - 补录凭证号',
        width: 600,
        height: 300,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-record-reserved-info :initReservedPayNo="reservedPayNo" :initReservedPayTime="reservedPayTime" ref="swb_record_reserved_info"></swb-record-reserved-info>' +
        '</div>',
        data: {
            reservedPayNo: reservedPayNo,
            reservedPayTime: reservedPayTime
        },
        okClicked: function () {
            let result = this.$refs.swb_record_reserved_info.getDlgResult() || {};
            if(result.type === 'info') {
                let reservedInfo = result.data;
                callback(reservedInfo);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/payment/showDlg.js
// module id = 2713
// module chunks = 0